export default {
  template: {
    title: '候选人问卷管理',
    menu: '候选人问卷管理',
    taskTitle: '模板更新任务管理'
  },
  label: {
    group: '模板',
    groupName: '模板名称',
    questionType: '问题类型',
    subQuestionType: '子问题类型',
    parentQuestion: '父问题',
    triggerOption: '触发选项',
    questionTitle: '问题',
    requiredQuestion: '设为必填问题',
    includeKnockoutOptions: '包含淘汰选项',
    createUpdateTask: '创建更新任务',
    options: '选项',
    allOptions: '全部选项',
    markAsKnockoutOptions: '标记为淘汰项',
    unGrouped: '未分组',
    duration: '视频长度限制',
    visibility: '可见性',
    templateName: '模板名称',
    updateJobs: '更新的职位',
    executeTime: '预计开始时间',
    executeStatus: '状态',
    finishTime: '完成时间',
    noJobs: '无',
    taskStatus: {
      pending: '待执行',
      executing: '执行中',
      success: '执行成功',
      failure: '执行失败'
    },
    status: '状态',
    otherGroup: '———————— 未分组 ————————'
  },
  editor: {
    group: {
      title: {
        add: '添加模板',
        edit: '编辑模板'
      }
    },
    question: {
      title: {
        add: '添加问题',
        edit: '编辑问题'
      }
    },
    subQuestion: {
      title: { add: '添加子问题', edit: '编辑子问题' }
    }
  },
  questionType: {
    TEXT: '问答题',
    SELECT: '单选题',
    CHECKBOX: '多选题',
    VIDEO: '视频题',
    ATTACHMENT: '附件题',
    SINGLE_SELECT: '下拉单选题',
    MULTIPLE_SELECT: '下拉多选题',
    DATE: '日期题'
  },
  btn: {
    addGroup: '添加模板',
    addQuestion: '添加问题',
    addNewGroup: '添加模板',
    addNewQuestion: '添加问题',
    addSubQuestion: '添加子问题',
    moveQuestion: '移动到',
    taskList: '任务列表',
    back: '返回',
    addQuestionFromTemplate: '从模板中添加',
    questionOptions: {
      expand: '显示选项',
      collapse: '隐藏选项'
    },
    setChild: '添加子问题',
    changeChild: '修改子题',
    removeChild: '移除子题'
  },
  placeholder: {
    questionTypeFilter: '选择问题类型',
    groupFilter: '选择模板',
    groupQuestionKeywordsFilter: '按照问题进行搜索',
    options: '选项1\n选项2\n选项3\n...等',
    markAsKnockoutOptions: '选择淘汰项'
  },
  message: {
    unsupportedTemplateType: '该题目树包含当前问卷不支持的题型。',
    selectChildWithRoot: '子题须随所属根题一起选择。',
    noSelectableTemplate: '该分组没有可用于当前问卷的题目树。',
    deleteQuestionLabel: '删除题目',

    notKnockoutOptionsTip: '填写答题选项，或者直接从Excel中复制。',
    knockoutOptionsTip: '当候选人回答了淘汰选项后会被系统自动标记状态为不合格。',
    executeTime: '该执行时间为预估时间，实际执行以系统内任务排队情况为准，一般会在执行时间开始后10分钟内完成。',
    duplicateTitle: '问题重复，请检查修改后重新提交。',
    confirmEnable: {
      disable: '确定禁用？',
      enable: '确定激活？'
    },
    confirmDeleteQuestion: '确定删除该问题？',
    confirmDeleteQuestionTree: '确定删除该问题及其所有子问题？',
    confirmRemoveChild: '确定移除此选项与子题的关联？',
    removeLinkedOptionFirst: '该选项已设置子题，请先移除子题关系后再编辑选项。',
    invalidTemplateTree: '模板问题树不完整、存在循环或超过最大深度，无法添加，请先修复模板。',
    treeDropInsideNotAllowed: '问题不能放入其他问题树内部。',
    treeStatusChangeNotAllowed: '子问题状态跟随根问题，不能单独修改。',
    fillQuestionRequired: '请填写问题内容',
    questionNotFound: '未找到该问题',
    noAvailableChildOption: '没有可用于添加子问题的非淘汰未占用选项。',
    subQuestionUnsupportedParent: '只有单选题和下拉单选题可以添加子问题。',
    subQuestionMaxDepth: '问题树已达到最大层级，不能再添加子问题。',
    selectTriggerOptionRequired: '请选择触发选项。',
    confirmDeleteQuestionCount: '确定删除该问题树吗？将删除 {count} 个问题。',
    cycleDetected: '问题树中存在循环引用'
  },
  questionTypeShort: {
    text: '问答',
    dropdown: '单选',
    single_select: '下拉单选',
    checkbox: '多选',
    multiple_select: '下拉多选',
    video: '视频',
    portfolio: '附件',
    date: '日期'
  },
  visibilityType: {
    IE: '内外部可见',
    I: '仅内部可见',
    E: '仅外部可见'
  }
}
